import { Col, formatNumber, Row } from '@dec/shared';
import { Alert, Card } from 'react-bootstrap';
import { CurrencyDollar, FileEarmark } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import env from '../../../../env';
import DateParser from '../../../../utils/date';
import { type InfoTaxreturnsAndPayments } from '../types';

export const TaxreturnsAndPayments = ({
  // taxpayerId,
  data
}: {
  //  taxpayerId: string;
  data: Array<InfoTaxreturnsAndPayments>;
}) => {
  const { t } = useTranslation();
  // const [{ data, loading, error }] = useGetInfoCollectionTaxpayer(taxpayerId);
  //
  // if (loading || error) {
  //   return <></>;
  // }

  if (data.length == 0) {
    return (
      <Row>
        <Col>
          <Alert variant="warning">{t('common.label.noFound')}</Alert>
        </Col>
      </Row>
    );
  }
  return (
    <>
      {data.map((x) => {
        const link =
          x.type === 'taxreturn'
            ? `${env.appUrl}/reports/taxreturn/preview/${x.id}`
            : `${env.appUrl}/reports/payments/check-load-records/${x.id}`;
        return (
          <div key={x.id} className="py-2">
            <Card>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>{x.type === 'taxreturn' ? <FileEarmark /> : <CurrencyDollar />}</div>
                    <div className="pl-3">
                      <div className="pair-title">{t('common.label.date')}</div>
                      <div
                        role="button"
                        className="pair-value"
                        onClick={() => {
                          window.open(link, '_blank', 'noopener,noreferrer');

                          // /reports/taxreturn/preview/03e00e77-004a-4a10-9dc6-af3d00cc6fbe
                        }}
                      >
                        <u>{DateParser.toString(x.date)}</u>
                      </div>
                    </div>
                    {x.type === 'taxreturn' && (
                      <>
                        <div className="pl-4">
                          <div className="pair-title">{t('non-compliances.label.period')}</div>
                          <div className="pair-value">{x.period}</div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="pl-2 d-flex justify-content-end " style={{ width: '30%' }}>
                    <div className="pair-value">{formatNumber(x.value)}</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        );
      })}
    </>
  );
};
